<template>
  <!--
    BillCellElementLite — счета (Category Bills, DisplayType 18).
    Сам Bill это объект, его рисует готовый общий компонент bill-row
    (зарегистрирован глобально), как и в легаси BillCellElement. Здесь только
    лёгкая обёртка-ряд, без q-* и лишней разметки. Сам bill-row не трогаем.
  -->
  <div class="qtl-bill">
    <bill-row v-for="(rec, i) in bills" :key="i" :el="rec" />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { TableDataCellDisplayType } from "@/models/etc/types";
import type { CellDataBill, TableDataCell } from "@/models/interfaces/entity-settings/querytable/querytable";

const props = defineProps<{ element: TableDataCell }>();

// Возвращаем именно объекты Bill (как legacy BillCellElement.getElements),
// дальше их форматирует bill-row. Для не-Bill ничего не рисуем.
const bills = computed(() => {
  if (props.element.DisplayType === TableDataCellDisplayType.Bill) {
    return (props.element.Data as CellDataBill[]).map((d) => d.Bill);
  }
  return [];
});
</script>

<style lang="scss" scoped>
.qtl-bill {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  max-width: 100%;
  font-size: 13px;
}
</style>
